import { createStandaloneToast } from '@chakra-ui/react'

import { chakraTheme } from './chakraTheme'

const { toast: standaloneToast, ToastContainer } = createStandaloneToast({
  defaultOptions: { position: 'top' },
  theme: chakraTheme,
})

export const showSuccess = (successMessage: string) =>
  standaloneToast({
    description: successMessage,
    status: 'success',
    isClosable: true,
  })

export const showError = (errorMessage: string) =>
  standaloneToast({ description: errorMessage, status: 'error', isClosable: true })

export const showInfo = (infoMessage: string) =>
  standaloneToast({ description: infoMessage, status: 'info', isClosable: true })

export const showWarning = (warningMessage: string) =>
  standaloneToast({ description: warningMessage, status: 'warning', isClosable: true })

export { standaloneToast, ToastContainer }
